import { Link as RouterLink } from "react-router-dom";
import { Box, Flex, Grid, Link, Text } from "@chakra-ui/react";
import FitLogo from "../fitness/FitLogo";
import { ACCENT, FG, GRID, MUTED } from "../theme";
import { EMAIL, NAV, SOCIALS } from "../data/site";
import { Container, Display, Em, Mono } from "./ui";

const FootLink = ({ to, href, children }) => (
  <Link
    as={to ? RouterLink : undefined}
    to={to}
    href={href}
    isExternal={!!href}
    color={MUTED}
    fontSize="sm"
    _hover={{ color: FG, textDecoration: "none" }}
    display="block"
    py={1}
  >
    {children}
  </Link>
);

const Footer = () => (
  <Box as="footer" borderTop={`1px solid ${GRID}`} mt={{ base: 20, md: 32 }} position="relative" overflow="hidden">
    <Container pt={{ base: 14, md: 20 }} pb={10}>
      <Grid templateColumns={{ base: "1fr", lg: "1.6fr 1fr 1fr" }} gap={{ base: 12, lg: 10 }}>
        <Box>
          <Mono mb={5}>A robot, a rally, or a rabbit hole?</Mono>
          <Display size="lg" as="h2" mb={6}>
            Say <Em>hello.</Em>
          </Display>
          <Link
            href={`mailto:${EMAIL}`}
            fontSize={{ base: "lg", md: "2xl" }}
            fontWeight={500}
            color={FG}
            borderBottom={`1px solid ${GRID}`}
            pb={1}
            _hover={{ color: ACCENT, borderColor: ACCENT, textDecoration: "none" }}
            transition="all 0.2s"
          >
            {EMAIL}
          </Link>
        </Box>
        <Box>
          <Mono mb={4}>Explore</Mono>
          <FootLink to="/">Home</FootLink>
          {NAV.map(({ label, to }) => (
            <FootLink key={to} to={to}>
              {label}
            </FootLink>
          ))}
          <FootLink to="/fitness/engine">How my fitness score works</FootLink>
          <FootLink to="/contact">Contact</FootLink>
        </Box>
        <Box>
          <Mono mb={4}>Elsewhere</Mono>
          {SOCIALS.map(({ label, href, handle }) => (
            <FootLink key={label} href={href}>
              {label} <Text as="span" color="#5c5b56">· {handle}</Text>
            </FootLink>
          ))}
          <FootLink href="https://logtennis.net">logtennis.net</FootLink>
        </Box>
      </Grid>

      <Flex
        mt={{ base: 14, md: 20 }}
        pt={6}
        borderTop={`1px solid ${GRID}`}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        direction={{ base: "column", md: "row" }}
        gap={4}
      >
        <Flex align="center" gap={3}>
          <FitLogo size={22} animate={false} />
          <Mono>© {new Date().getFullYear()} Pratik Chawla — designed &amp; built by hand</Mono>
        </Flex>
        <Mono>Built in the SF Bay Area</Mono>
      </Flex>
    </Container>
  </Box>
);

export default Footer;
